import type { ReactElement } from "react";
import { Skeleton } from "@/components/atoms";
import "./CastingCardSkeleton.scss";

/** Loading placeholder matching CastingCard layout. */
export function CastingCardSkeleton(): ReactElement {
  return (
    <div className="casting-card-skeleton" aria-hidden="true">
      <div className="casting-card-skeleton__header">
      <Skeleton variant="text" width="80%" height={28} borderRadius="base" />
        <div className="casting-card-skeleton__badges">
          <Skeleton width={100} height={28} borderRadius="lg" />
          <Skeleton width={80} height={28} borderRadius="lg" />
        </div>
      </div>  
      <Skeleton width="90%" height={120} borderRadius="lg" /> 
      <div className="casting-card-skeleton__footer">
        <Skeleton variant="text" width={120} height={16} />
        <Skeleton height={44} borderRadius="lg" />
      </div>
    </div>
  );
}
